module.exports = __webpack_public_path__ + "img/nas.b23e564c.svg";